import React, { useEffect, useState } from 'react';
import './Component_Landscape_Prompt.css';

const Component_Landscape_Prompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      const isMobile = window.innerWidth <= 768;
      const isPortrait = window.innerHeight > window.innerWidth;
      
      if (isMobile && isPortrait) {
        setShowPrompt(true);
      } else {
        setShowPrompt(false);
      }
    };

    // Check on mount
    checkOrientation();

    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!showPrompt) return null;

  return (
    <div className="landscape-prompt-overlay">
      <div className="landscape-prompt-container">
        <div className="landscape-prompt-header">
          <div className="landscape-prompt-spacer"></div>
          <h2 className="landscape-prompt-title">Rotate Device</h2>
          <div className="landscape-prompt-spacer"></div>
        </div>
        
        <div className="landscape-prompt-content">
          <div className="landscape-prompt-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="6" width="18" height="12" rx="2" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 9L15 12L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 12H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <p className="landscape-prompt-message">
            Please rotate your device to landscape mode for the best experience
          </p>
        </div>
      </div>
    </div>
  );
};

export default Component_Landscape_Prompt;